// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Gb3m","filesListContainer":"PosDisputesFiles_filesListContainer__2WLcR","filesButton":"PosDisputesFiles_filesButton__2zhgz"};